import {BiListUl} from "react-icons/bi";
import UILinkButton from "./UILinkButton";

/**
 * This button navigates the user to the 'List View' page when clicked.
 */
const ListLinkButton = () => {
  return (
    <UILinkButton to="/list" title="List View" icon=<BiListUl/> />
  );
};
export default ListLinkButton;